import { useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import React, { useState } from "react";
import stringOrFirst from "~/src/utils/stringOrFirst";
import SearchProjectsQuery from "~/src/components/project/graphql/SearchProjectsQuery";
import { ISearchProjectsQuery } from "~/src/components/project/graphql/__generated__/SearchProjectsQuery.generated";
import ProjectsListing from "~/src/components/project/listing/ProjectsListing";
import ProjectsPageFilters from "~/src/components/project/listing/ProjectsPageFilters";
import ProjectsPageHeader from "~/src/components/project/listing/ProjectsPageHeader";
import { PageGridContainer } from "@govlaunch/web";
import nextLinkHref from "~/src/utils/nextLinkHref";
import stripUndefined from "~/lib/utils/stripUndefined";
import ProjectsPageSeo from "~/components/seo/ProjectsPageSeo";

export default function ProjectsListingPage() {
  const router = useRouter();

  const variables = {
    title: stringOrFirst(router.query.title),
    country: stringOrFirst(router.query.country),
    state: stringOrFirst(router.query.state),
    tags: Array.isArray(router.query.tags) ? router.query.tags : router.query.tags ? [router.query.tags] : [],
  };

  const [latestFilters, setLatestFilters] = useState(variables);

  const { data, loading, fetchMore } = useQuery<ISearchProjectsQuery>(SearchProjectsQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return (
    <div>
      <ProjectsPageSeo />

      <ProjectsPageFilters />

      <ProjectsPageHeader />

      <PageGridContainer>
        <div>
          <ProjectsListing
            firstLocationCountry={variables.country}
            projects={data?.searchProjects?.items || []}
            projectNavigationLimit={Infinity}
            loading={loading}
            hasNextPage={data?.searchProjects?.pageInfo?.hasNextPage || false}
            onClickProject={() => {
              setLatestFilters(variables);
            }}
            onLoadMore={async () => {
              await fetchMore({
                variables: {
                  cursor: data?.searchProjects?.pageInfo?.endCursor,
                },
                updateQuery: (previousQueryResult, { fetchMoreResult }) => {
                  if (!fetchMoreResult?.searchProjects) {
                    return previousQueryResult;
                  }

                  return {
                    ...fetchMoreResult,
                    searchProjects: {
                      ...fetchMoreResult.searchProjects,
                      items: [
                        ...(previousQueryResult.searchProjects?.items || []),
                        ...(fetchMoreResult.searchProjects.items || []),
                      ],
                    },
                  };
                },
              });
            }}
            onModalClose={() => {
              router.push(nextLinkHref("/projects", stripUndefined(latestFilters)));
            }}
          />
        </div>
      </PageGridContainer>
    </div>
  );
}
